// extracted by mini-css-extract-plugin
export default {"createFooter":"FooterBar_createFooter__jTjtr","NextBtn":"FooterBar_NextBtn__2VWnW","BackBtn":"FooterBar_BackBtn__g8bEX","disabledBtn":"FooterBar_disabledBtn__Qw70K"};